import Image from "components/common/Image";
import { useLifeChoicePageContext } from "context/hooks/useLifeChoicePageContext";
import { useModal } from "context/hooks/useModal";
import React, { FC } from "react";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";
import styles from "../index.module.scss";
import TechnicalSkillModal from "./TechnicalSkillModal";
import { t } from "i18next";

const TechnicalSkills: FC = () => {
  const { lifeChoice } = useLifeChoicePageContext();
  const { showModal } = useModal();
  const { dir, language } = useAppSelector(getSettings);

  const skills = lifeChoice?.tech_skills;

  skills.slice(0).sort((a, b) => {
    if (a.value && b.value) {
      return a.value - b.value;
    }
    return 0;
  });

  return (
    <div
      className={`${styles["technical-skills"]} w-full`}
      dir={dir}
      lang={language}
    >
      <h4 className="text-lg font-semibold py-4" lang={language} dir={dir}>
        {t("technicalSkills") as string}
      </h4>
      <ul
        className="grid"
        role="list"
        style={{ "--cols": 3, "--cols-mobile": 3 } as any}
      >
        {skills.slice(0, 9).map((data, idx) => {
          const skill = data?.id;
          return (
            <li
              key={`--technical-skill-${idx}`}
              className={`${styles["technical-skill"]} cursor-pointer`}
              onClick={() =>
                showModal(<TechnicalSkillModal skill={skill} />, "sm")
              }
            >
              <Image src={ skill.logo ? process.env.REACT_APP_CLOUDFRONT_URL + skill.logo : require(`assets/images/skills/tech_skill_image_placeholder_${language}.png`)} />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default TechnicalSkills;
